/**
 * Font registry — the files expo-font loads at startup.
 *
 * Two families ship: GeneralSans (main typeface → `$body`) and Gochi Hand (the
 * handwritten accent → `$hand`). GeneralSans loads two real weights (Medium 500,
 * Semibold 600); every other numeric weight is mapped onto one of those in the
 * `face` map in tamagui.config.ts. The KEY STRINGS here must match the `face`
 * map exactly or per-weight rendering silently falls back on native.
 */
export const FONT_ASSETS = {
  'GeneralSans-Medium': require('../../assets/fonts/GeneralSans-Medium.otf'),
  'GeneralSans-Semibold': require('../../assets/fonts/GeneralSans-Semibold.otf'),
  GochiHand: require('../../assets/fonts/GochiHand-Regular.ttf'),
} as const;
